import { graphql } from 'gatsby';
import {
  StyledLink,
  StyledDescription,
  StyledTitle,
  StyledImage,
  StyledIcon,
} from './ColumnSectionLink.styles';
import useLinkProps from '@/components/Link/hooks/useLinkProps';

const DEFAULT_IMAGE_WIDTH = 176;
const DEFAULT_IMAGE_HEIGHT = 48;

const ColumnSectionLink = ({ elements }: Queries.HEADER_COLUMN_SECTION_LINKFragment) => {
  const {
    link: {
      value: { linkElements },
    },
    description,
    image,
  } = elements;
  const { linkChildren, linkProps } = useLinkProps({
    action: linkElements.action.value,
    target: linkElements.target?.value,
  });
  const imageValue = image?.value && {
    ...image.value,
    description: image.value.description || undefined,
    width: image.value.width ?? DEFAULT_IMAGE_WIDTH,
    height: image.value.height ?? DEFAULT_IMAGE_HEIGHT,
  };
  const hasIcon = !!linkElements.icon?.value?.url;

  return (
    <StyledLink {...linkProps} role="menuitem">
      {imageValue && (
        <StyledImage
          image={{
            ...imageValue,
            image_id: imageValue.url,
          }}
          width={imageValue.width}
          height={imageValue.height}
          alt={imageValue.description}
          layout="fullWidth"
        />
      )}
      {linkChildren}
      <StyledTitle>
        {hasIcon && <StyledIcon {...linkElements.icon.value} />}
        {linkElements.text.value}
      </StyledTitle>
      {description?.value && <StyledDescription>{description.value}</StyledDescription>}
    </StyledLink>
  );
};

export const fragment = graphql`
  fragment HEADER_COLUMN_SECTION_LINK on kontent_item_header_column_section_link {
    system {
      id
    }
    elements {
      link {
        value {
          ...LINK
        }
      }
      description {
        value
      }
      image {
        value {
          description
          url
          width
          height
        }
      }
    }
  }
`;

export default ColumnSectionLink;
